import React from 'react'
import {
  Box,
  Button,
  Typography
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'
import { LoadingSpinner } from '../atoms'
import AutomationCard from './AutomationCard'
import styles from '../../views/settings/SettingsNotifications.module.scss'

const AutomationsTab = ({
  automations,
  loading,
  onCreateNew,
  onEdit,
  onDelete,
  onToggle,
  onTest,
  onManageCampaigns
}) => {
  if (loading) {
    return (
      <LoadingSpinner />
    )
  }

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" style={{ gap: 12 }} mb={3}>
        <Typography variant="h6">Email Automations</Typography>
        {automations.length > 0 && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<FontAwesomeIcon icon={faPlus} />}
            onClick={onCreateNew}
          >
            Create Automation
          </Button>
        )}
      </Box>

      {automations.length === 0 ? (
        <Box textAlign="center" p={4}>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            No automations configured
          </Typography>
          <Typography variant="body2" color="textSecondary" paragraph>
            Create your first email automation to get notified when campaigns reach usage thresholds.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<FontAwesomeIcon icon={faPlus} />}
            onClick={onCreateNew}
          >
            Create First Automation
          </Button>
        </Box>
      ) : (
        <div className={styles.automationsGrid}>
          {automations.map(automation => (
            <AutomationCard
              key={automation.id}
              automation={automation}
              onEdit={onEdit}
              onDelete={onDelete}
              onToggle={onToggle}
              onTest={onTest}
              onManageCampaigns={onManageCampaigns}
              className={styles.automationCard}
            />
          ))}
        </div>
      )}
    </Box>
  )
}

AutomationsTab.propTypes = {
  automations: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  onCreateNew: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  onTest: PropTypes.func.isRequired,
  onManageCampaigns: PropTypes.func.isRequired
}

export default AutomationsTab